export enum EApiCallStateNames {
  BOOKLETS = 'BOOKLETS',
  ADMIN_BOOKLETS_LIST = 'ADMIN_BOOKLETS_LIST',
  ADMIN_ACCOUNTING_BOOKLETS_LIST = 'ADMIN_ACCOUNTING_BOOKLETS_LIST',
  ADMIN_PARTNERS_LIST = 'ADMIN_PARTNERS_LIST',
  ADMIN_DASHBOARD = 'ADMIN_DASHBOARD',
}

export enum EApiRequestPartKeys {
  SEARCH = 'SEARCH',
  PAGINATION = 'PAGINATION',
  FILTERS = 'FILTERS',
  SORTING = 'SORTING',

  SORTING_ADMIN_BOOKLETS_LIST_AGENCY = 'SORTING_ADMIN_BOOKLETS_LIST_AGENCY',
  SORTING_ADMIN_BOOKLETS_LIST_STATUS = 'SORTING_ADMIN_BOOKLETS_LIST_STATUS',
  SORTING_ADMIN_BOOKLETS_LIST_CREATED_AT = 'SORTING_ADMIN_BOOKLETS_LIST_CREATED_AT',
  SORTING_ADMIN_BOOKLETS_LIST_PROPERTY_ADDRESS = 'SORTING_ADMIN_BOOKLETS_LIST_PROPERTY_ADDRESS',
  SORTING_ADMIN_BOOKLETS_LIST_SELLER_SURNAME = 'SORTING_ADMIN_BOOKLETS_LIST_SELLER_SURNAME',
  SORTING_ADMIN_BOOKLETS_LIST_AGENT_SURNAME = 'SORTING_ADMIN_BOOKLETS_LIST_AGENT_SURNAME',
  // eslint-disable-next-line max-len
  SORTING_ADMIN_BOOKLETS_LIST_TECHNICAL_REPORT_SURVEYOR = 'SORTING_ADMIN_BOOKLETS_LIST_TECHNICAL_REPORT_SURVEYOR',
  SORTING_ADMIN_BOOKLETS_LIST_APE_SURVEYOR = 'SORTING_ADMIN_BOOKLETS_LIST_APE_SURVEYOR',
  SORTING_ADMIN_BOOKLETS_LIST_EXTRA_SURVEYOR = 'SORTING_ADMIN_BOOKLETS_LIST_EXTRA_SURVEYOR',

  SORTING_ADMIN_ACCOUNTING_CREATED_AT = 'SORTING_ADMIN_ACCOUNTING_CREATED_AT',
  SORTING_ADMIN_ACCOUNTING_PROPERTY_DEED_OF_SALE = 'SORTING_ADMIN_ACCOUNTING_PROPERTY_DEED_OF_SALE',
  SORTING_ADMIN_ACCOUNTING_AGENCY = 'SORTING_ADMIN_ACCOUNTING_AGENCY',
  SORTING_ADMIN_ACCOUNTING_PROPERTY_ADDRESS = 'SORTING_ADMIN_ACCOUNTING_PROPERTY_ADDRESS',
  SORTING_ADMIN_ACCOUNTING_SELLER_SURNAME = 'SORTING_ADMIN_ACCOUNTING_SELLER_SURNAME',
  SORTING_ADMIN_ACCOUNTING_TECHNICAL_REPORT_SURVEYOR = 'SORTING_ADMIN_ACCOUNTING_TECHNICAL_REPORT_SURVEYOR',
  SORTING_ADMIN_ACCOUNTING_APE_SURVEYOR = 'SORTING_ADMIN_ACCOUNTING_APE_SURVEYOR',
  SORTING_ADMIN_ACCOUNTING_EXTRA_SURVEYOR = 'SORTING_ADMIN_ACCOUNTING_EXTRA_SURVEYOR',

  SORTING_ADMIN_PARTNERS_LIST_AGENCY = 'SORTING_ADMIN_PARTNERS_LIST_AGENCY',
  SORTING_ADMIN_PARTNERS_LIST_CREATED_AT = 'SORTING_ADMIN_PARTNERS_LIST_CREATED_AT',
  SORTING_ADMIN_PARTNERS_LIST_PROPERTY_ADDRESS = 'SORTING_ADMIN_PARTNERS_LIST_PROPERTY_ADDRESS',
  SORTING_ADMIN_PARTNERS_LIST_SELLER_SURNAME = 'SORTING_ADMIN_PARTNERS_LIST_SELLER_SURNAME',
}
